import React from "react"
import "./Navigation.css"
import CompanyLogoOnlySVG from "../assets/svg/logo/company logo only.svg"
import CompanyLogoTextOnlySVG from "../assets/svg/logo/company logo text only.svg"
import EmailIconSVG from "../assets/svg/icons/mail.svg"
import { NavLink } from "react-router-dom"
import SVG from "react-inlinesvg"

export const Navigation: React.FC = () => {
    const [isScrolled, setIsScrolled] = React.useState(false)

    React.useEffect(() => {
        const scrollHandler = () => {
            setIsScrolled(window.scrollY > 15)
        }

        window.addEventListener('scroll', scrollHandler)

        return () => {
            window.removeEventListener('scroll', scrollHandler)
        }
    }, [])

    const scrollIDIntoView = React.useCallback<(id: string) => void>((id) => {
        const element = document.getElementById(id)

        if (element) {
            window.scrollTo({
                behavior: "smooth",
                top: element.offsetTop - 150
            })
        }
    }, [])

    return (
        <nav is-scrolled={isScrolled ? "true" : null}>
            <NavLink id="nav-logo" to="/" onClick={() => scrollIDIntoView("landing")} aria-label="Home">
                <SVG src={CompanyLogoOnlySVG} />
                <SVG src={CompanyLogoTextOnlySVG} />
            </NavLink>

            {/* <NavLink to="#vision" onClick={() => scrollIDIntoView("vision")}>Vision</NavLink> */}
            <NavLink to="#values" onClick={() => scrollIDIntoView("values")}>Culture</NavLink>
            <NavLink to="#team" onClick={() => scrollIDIntoView("team")}>Team</NavLink>

            {/* <NavLink to="#contact" is-desktop="true" onClick={() => scrollIDIntoView("contact")}>Contact</NavLink> */}

            <NavLink to="#contact" onClick={() => scrollIDIntoView("contact")} aria-label="Contact">
                <SVG src={EmailIconSVG} width="21" height="21" />
            </NavLink>
        </nav>
    )
}
